import Script from 'next/script';

export default function AmplitudeScript() {
  return (
    <Script
      id="amplitude-script"
      type="text/javascript"
      integrity="sha384-xwN6OCSgIf1SF9jtD6pouaSwCvpobyV3lanBGQ1d33MwTxLarbQxUif0Slt0npCM"
      crossOrigin="anonymous"
      src="https://cdn.amplitude.com/libs/amplitude-8.3.0-min.gz.js"
      strategy="afterInteractive"
    />
  );
}
